import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import viewerReducer from './viewer';
import proposalReducer from './proposal';
import costCenterReducer from './costCenter';
import optionsReducer from './options';

const rootReducer = combineReducers({
    viewer: viewerReducer,
    proposalData: proposalReducer,
    costCenterData: costCenterReducer,
    routing: routerReducer,
    options: optionsReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js